import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';
import { LocationVarKey } from '@swivl-mono/types';
import {TextRow, Indent, InputRow, TextAreaRow, DropdownRow, MultiLineRow, SwitchRow, SectionHeader, PageHeader, Section } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';
import { IS_NOT_EQUAL, IS_EQUAL, IS_TRUE } from '../../../Components/Worksheets/Types/Worksheet.Interface';

export default  function WorksheetView() {
    const page = usePropertiesGetLocationIds();  
  return  <>
   
        
   <PageHeader {...page} subheading="For first time users, require customers to provide their contact information before they can chat with the bot or a human." > Welcome</PageHeader>
    
        <SwitchRow {...page}  keyName= {LocationVarKey.ProfileSettingWelcomeCollectProfile} label="Collect Profile" />
        <Section {...page} hideIf= {IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeCollectProfile, "1")}>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.ProfileSettingWelcomeMessage}
        />
        <DropdownRow {...page}  
        marginTop
        label=" Collection Method"
        keyName= {LocationVarKey.ProfileSettingWelcomeCollectionMethod}
        options={[
            {
                label:"Conversational",
                value:"Conversational"
            },
            {
                label:"Info Collect Card",
                value:"Card"
            }
        ]} />
        <DropdownRow {...page}  
        marginTop
        label=" Preferred Contact Method"
        keyName= {LocationVarKey.ProfileSettingWelcomeContactMethod}
        options={[
            {
                label:"Phone Number",
                value:"Phone"
            },
            {
                label:"Email",
                value:"Email"
            }
        ]} />
        <SwitchRow {...page}  keyName= {LocationVarKey.ProfileSettingWelcomeWantShortProfile}  label="Short Profile" />
        <Indent {...page} >
            <SwitchRow {...page}  keyName= {LocationVarKey.ProfileSettingWelcomeWantSecondaryOptional} hideIf={IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeWantShortProfile,"1")} label="Make Secondary Contact Method Optional" />
        </Indent>
        <SwitchRow {...page}  keyName= {LocationVarKey.ProfileSettingWelcomeWantConfirmProfile} label="Confirm Profile" />
        <SwitchRow {...page}  keyName= {LocationVarKey.ProfileSettingWelcomeWantCollectPersona} label="Collect Persona" />
        </Section>


        

       
       


    </>
}